// assets
import MenuDashboard from 'ui-component/icons/menuDashboard';
import { Menu } from './type';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard: Menu = {
  id: 'dashboard',
  title: '仪表盘',
  type: 'group',
  children: [
    {
      id: 'default',
      title: '账户概览',
      i18nTitle: 'dashboard',
      type: 'item',
      url: '/dashboard',
      icon: MenuDashboard,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
